import { render, staticRenderFns } from "./ToExpireLabsBlock.vue?vue&type=template&id=7566a840&scoped=true&"
import script from "./ToExpireLabsBlock.vue?vue&type=script&lang=ts&"
export * from "./ToExpireLabsBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7566a840",
  null
  
)

export default component.exports